import React, { useEffect, useState } from 'react';
import { Card, PageHeader, Badge } from '../../components/shared/ui';
import { adminAPI } from '../../utils/api';

const AuditLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.getAuditLogs().then(r => setLogs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const tone = (a) => {
    if (a?.includes('login')) return 'blue';
    if (a?.includes('register')) return 'green';
    if (a?.includes('delete') || a?.includes('reject')) return 'red';
    if (a?.includes('approve')) return 'green';
    return 'gray';
  };

  return (
    <>
      <PageHeader title="Audit Log" description="Sistemde gerçekleşen aksiyonların kaydı" />
      <Card padded={false}>
        {loading ? (
          <div className="p-10 text-center text-ink-400">Yükleniyor...</div>
        ) : logs.length === 0 ? (
          <div className="p-10 text-center text-ink-400">Henüz log yok</div>
        ) : (
          <>
            {/* Desktop tablo */}
            <div className="hidden md:block overflow-x-auto">
              <table className="w-full">
                <thead className="bg-ink-50 border-b border-ink-200">
                  <tr>{['Zaman','Kullanıcı','Aksiyon','Hedef','IP','Durum'].map(h =>
                    <th key={h} className="px-4 py-2.5 text-left text-xs font-semibold text-ink-600">{h}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {logs.map(l => (
                    <tr key={l.id} className="border-b border-ink-100">
                      <td className="px-4 py-2.5 text-xs text-ink-500 whitespace-nowrap">
                        {new Date(l.created_at).toLocaleString('tr-TR', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' })}
                      </td>
                      <td className="px-4 py-2.5 text-sm">
                        <div className="text-ink-900">{l.email || '—'}</div>
                        {l.role && <div className="text-[11px] text-ink-400">{l.role}</div>}
                      </td>
                      <td className="px-4 py-2.5"><Badge tone={tone(l.action)}>{l.action}</Badge></td>
                      <td className="px-4 py-2.5 text-xs text-ink-500 max-w-[180px] truncate">{l.target || '—'}</td>
                      <td className="px-4 py-2.5 text-xs text-ink-500">{l.ip || '—'}</td>
                      <td className="px-4 py-2.5">
                        <span className={`text-xs font-semibold ${l.status_code < 400 ? 'text-emerald-600' : 'text-red-600'}`}>
                          {l.status_code || '—'}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile kart liste */}
            <div className="md:hidden divide-y divide-ink-100">
              {logs.map(l => (
                <div key={l.id} className="p-3">
                  <div className="flex items-center justify-between gap-2">
                    <Badge tone={tone(l.action)}>{l.action}</Badge>
                    <span className={`text-xs font-semibold ${l.status_code < 400 ? 'text-emerald-600' : 'text-red-600'}`}>{l.status_code || '—'}</span>
                  </div>
                  <div className="mt-1.5 text-sm text-ink-900 truncate">{l.email || '—'} {l.role && <span className="text-[11px] text-ink-400">· {l.role}</span>}</div>
                  {l.target && <div className="text-xs text-ink-500 truncate">{l.target}</div>}
                  <div className="mt-1 text-[11px] text-ink-400 flex items-center justify-between">
                    <span>{new Date(l.created_at).toLocaleString('tr-TR')}</span>
                    {l.ip && <span>{l.ip}</span>}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </Card>
    </>
  );
};

export default AuditLogs;
